import React, { ReactElement } from 'react';
import { useLocation } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth/lib/types';

import appleIcon from '../../assets/images/apple-icon.svg';
import googleIcon from '../../assets/images/google-icon.svg';
import facebookIcon from '../../assets/images/facebook-icon.svg';

import { triggerMobile } from '../../utils/app-bridge';
import useReturnUrl from '../../hooks/useReturnUrl';

type Props = {
  socialType: string
};

export default function SocialElement({ socialType }: Props): ReactElement {
  const { search } = useLocation();
  const queryString = new URLSearchParams(search);
  const os: string | null = queryString.get('os') || null;
  const redirectUrl = queryString.get('redirectUrl') || undefined;
  const returnUrl = useReturnUrl();

  const nativeLoginProviders = {
    ios: [],
    android: ['facebook'],
  };
  const amplifyLoginProviders = [
    { providerKey: 'apple', provider: CognitoHostedUIIdentityProvider.Apple },
    { providerKey: 'facebook', provider: CognitoHostedUIIdentityProvider.Facebook },
    { providerKey: 'google', provider: CognitoHostedUIIdentityProvider.Google },
  ];

  const socialLogin = (provider: string) => {
    let providers: string[] = [];
    if (os === 'ios') providers = nativeLoginProviders.ios;
    else if (os === 'android') providers = nativeLoginProviders.android;

    let triggered = false;
    providers.forEach((providerElement) => {
      if (provider === providerElement) {
        const payload = {
          'action': 'socialLogin',
          'data': {
            'social': 'facebook',
          },
        };
        triggerMobile(payload);
        triggered = true;
      }
    });
    if (!os || !triggered || providers.length === 0) {
      const providerConfig = amplifyLoginProviders.filter((element) => element.providerKey === provider);
      console.log('provider', providerConfig, providerConfig[0].provider);
      const goto = redirectUrl || returnUrl;
      if (goto) document.cookie = `federatedRedirectUrl=${goto}`;
      Auth.federatedSignIn({ provider: providerConfig[0].provider });
    }
  };

  switch (socialType) {
    case 'Facebook':
      return (
        <button className="btn btn-facebook" onClick={() => socialLogin(socialType.toLowerCase())}>
          <div className="social-icon-facebook"><img src={facebookIcon} /></div>
        </button>
      );
    case 'Google':
      return (
        <button className="btn btn-google-orig" onClick={() => socialLogin(socialType.toLowerCase())}>
          <div className="social-icon-google"><img src={googleIcon} /></div>
        </button>
      );
    case 'Apple':
      return (
        <button className="btn btn-apple-orig" onClick={() => socialLogin(socialType.toLowerCase())}>
          <div className="social-icon-apple"><img src={appleIcon} /></div>
        </button>
      );
    default:
      return <></>;
  }
}